import { useEffect, useState } from 'react';
import { Chart, registerables } from 'chart.js';
import { useRef } from 'react';
import DirectorioPanel from '../components/DirectorioPanel';
Chart.register(...registerables);

const API_URL = process.env.REACT_APP_API_URL;

function useChart(ref, config) {
  useEffect(() => {
    if (!ref.current) return;
    const chart = new Chart(ref.current, config);
    return () => chart.destroy();
  }, []);
}

export default function Dashboard({ currentUser, token }) {
  const isAdmin = currentUser?.rol === 'admin';
  const [data, setData] = useState(null);
  const [directorio, setDirectorio] = useState([]);
  const c1 = useRef(), c2 = useRef(), c3 = useRef();

  const nombre = currentUser?.nombre_completo || currentUser?.nombre || 'Usuario';

  useEffect(() => {
    Promise.all([
      fetch(`${API_URL}/dashboard`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
      fetch(`${API_URL}/usuarios/directorio`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).catch(() => []),
    ]).then(([dash, dir]) => {
      setData(dash);
      setDirectorio(Array.isArray(dir) ? dir : []);
    });
  }, []);

  useEffect(() => {
    if (!data) return;
    const isDark = matchMedia('(prefers-color-scheme: dark)').matches;
    const gridColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';
    const textColor = isDark ? '#aaa' : '#888';

    const c1i = new Chart(c1.current, {
      type: 'bar',
      data: {
        labels: data.porArea.map(r => r.area),
        datasets: [{ data: data.porArea.map(r => Number(r.total)), backgroundColor: '#378ADD', borderRadius: 4 }]
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { ticks: { color: textColor, font: { size: 11 } }, grid: { color: gridColor } },
          y: { ticks: { color: textColor, font: { size: 11 } }, grid: { color: gridColor }, beginAtZero: true }
        }
      }
    });

    const c2i = new Chart(c2.current, {
      type: 'doughnut',
      data: {
        labels: ['Disponibles', 'En uso'],
        datasets: [{ data: [Number(data.tarjetas.disponibles), Number(data.tarjetas.en_uso)], backgroundColor: ['#1D9E75', '#378ADD'], borderWidth: 0 }]
      },
      options: { responsive: true, maintainAspectRatio: false, cutout: '65%', plugins: { legend: { display: false } } }
    });

    const c3i = new Chart(c3.current, {
      type: 'bar',
      data: {
        labels: data.equiposViejos.map(e => `${e.marca} ${e.modelo}`),
        datasets: [{ data: data.equiposViejos.map(e => e.fecha_compra ? new Date(e.fecha_compra).getFullYear() : 0), backgroundColor: '#EF9F27', borderRadius: 4 }]
      },
      options: {
        indexAxis: 'y', responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { ticks: { color: textColor, font: { size: 11 }, callback: v => v }, grid: { color: gridColor } },
          y: { ticks: { color: textColor, font: { size: 11 } }, grid: { display: false } }
        }
      }
    });

    return () => { c1i.destroy(); c2i.destroy(); c3i.destroy(); };
  }, [data]);

  if (!data) return <p>Cargando...</p>;

  const initiales = (nombre) => nombre?.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase() ?? '?';
  if (nombre === 'Usuario') {
    return (<h2>Sesión caducada</h2>);
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h2 style={{ margin: 0 }}>Dashboard</h2>
      <p style={{ color: 'var(--text-secondary)', fontSize: 13 }}>Bienvenido, <b>{nombre}</b></p>

      <>
        {/* Directorio 
        <div className="card">
          <div className="card-header">
            <div className="card-title">Directorio telefónico</div>
          </div>

          {directorio.length === 0 ? (
            <p style={{ color: '#888', fontSize: 13 }}>Sin registros</p>
          ) : (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0 12px',
                maxHeight: 360,
                overflowY: 'auto',
                paddingRight: 4
              }}
            >
              {directorio.map((u, i) => (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '8px 0',
                    borderBottom: '1px solid var(--border)'
                  }}
                >
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      background: '#B5D4F4',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                      fontWeight: 500,
                      color: '#0C447C',
                      flexShrink: 0
                    }}
                  >
                    {initiales(u.nombre_completo)}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>
                      {u.nombre_completo}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                      {u.area_nombre ?? '—'}
                    </div>
                  </div>

                  <div style={{ flex: 2, gap: 6 }}>
                    {u.tel_ext && (
                      <span
                        style={{
                          fontSize: 11,
                          padding: '2px 8px',
                          borderRadius: 20,
                          background: '#EAF3DE',
                          color: '#3B6D11'
                        }}
                      >
                        Ext. {u.tel_ext}
                      </span>
                    )}
                    {u.numero_celular && (
                      <span
                        style={{
                          fontSize: 11,
                          padding: '2px 8px',
                          borderRadius: 20,
                          background: '#E6F1FB',
                          color: '#185FA5'
                        }}
                      >
                        {u.numero_celular}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>*/}

        {/* Gráficas (solo admin) */}
        {isAdmin && (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '1rem'
            }}
          >
            {/* 1. LARGA ARRIBA */}
            <div className="card" style={{ gridColumn: '1 / -1' }}>
              <div className="card-title">Equipos por área</div>
              <div style={{ position: 'relative', height: 220 }}>
                <canvas ref={c1} />
              </div>
            </div>

            {/* 2. IZQUIERDA ABAJO */}
            <div className="card">
              <div className="card-title">Estado de tarjetas</div>
              <div
                style={{
                  display: 'flex',
                  gap: 12,
                  marginBottom: 8,
                  fontSize: 12,
                  color: 'var(--text-secondary)'
                }}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: 2,
                      background: '#1D9E75',
                      display: 'inline-block'
                    }}
                  />
                  Disponibles
                </span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: 2,
                      background: '#378ADD',
                      display: 'inline-block'
                    }}
                  />
                  En uso
                </span>
              </div>
              <div style={{ position: 'relative', height: 200 }}>
                <canvas ref={c2} />
              </div>
            </div>

            {/* 3. DERECHA ABAJO */}
            <div className="card">
              <div className="card-title">Equipos más antiguos</div>
              <div style={{ position: 'relative', height: 180 }}>
                <canvas ref={c3} />
              </div>
            </div>
          </div>
        )}
      </>
      <DirectorioPanel token={token} />
    </div>
  );
}